module.exports = __webpack_public_path__ + "img/Onboarding_Asset_2.74e2df1c.svg";